import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ShowcaseService } from 'src/app/core/services/showcase/showcase.service';
import { PurchaseFlowComponent } from 'src/app/shared/cinejoy/common/purchase-flow/purchase-flow.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { RateMovieComponent } from '../dialog/new-post/rate-movie/rate-movie.component';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { StripePurchasePopupComponent } from 'src/app/features/bulk-purchase/stripe-purchase-popup/stripe-purchase-popup.component';
import { EventType } from 'src/app/features/passport/models/passport.models';
import { AgileIntegrationService } from 'src/app/core/services/agile/agile-integration.service';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { StripeConfirmationPopupComponent } from 'src/app/features/bulk-purchase/stripe-purchase-popup/stripe-confirmation-popup/stripe-confirmation-popup.component';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';

@Component({
  selector: 'app-movie-info',
  templateUrl: './movie-info.component.html',
  styleUrls: ['./movie-info.component.css'],
})
export class MovieInfoComponent implements OnInit {
  private static readonly stripPaymentSessionEventIdKey =
    'stripe_payment_session_id';
    purchaseCallback:boolean=false;
  router: any;
  public Comments: any = [];
  today: number = Date.now();
  Url: string;
  shareUrl: string;
  type: 'facebook' | 'twitter';
  isAgileGateWayActive: boolean = environment.showcaseAgilePurchaseEnabled;
  isButtonClicked:boolean=false;
  pageUrl: string = '';
  constructor(
    public ShowcasesService: ShowcaseService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private spotlightService: SpotlightService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private _location: Location,
    private routerurl: Router,
    private agileIntegration: AgileIntegrationService,
    private adminService:AdminService,
    private authService: AuthenticationService

  ) {
    this.id = route.snapshot.params.id;
  }

  data: any = { sourceType: 'url', url: 'https://twitter.com/Creatics2' };
  movie: any = [];
  GiveRate: string;
  Shorts: any = [];
  starCast: any = [];
  name: any;
  showSideBar: boolean = false;
  ShortDescriptive1: any = [];
  description: any = [];
  country: any = [];
  movieList: any = [];
  rating: number;
  language: string;
  duration: any;
  tags: any = [];
  categories: any = [];
  subCategories: any = [];
  id: any;
  public errorApi = true;
  result = [];
  dates: any;
  subCat: any = [];
  backArrow = "assets/images/cinejoy/arrow-left.png";
  officialLogo = "assets/images/spotlight/Laurel.svg"
  trailerUrl: any;
  spotlightMovies: any = [];
  counter = 0;
  isSecondarySideNavOpen: boolean;
  screeningPartyList: any = [];
  splContent: any;
  splContent1: any;
  isBuyButtonActive:boolean=false;
  showcaseTickets: any = new Array();
  ngOnInit(): void {
    this.getShowcaseList();
    this.authService.checkUserAuthenticated().subscribe((res)=>{
      if(res.userId > 0){
        this.fetchTickets();
        this.getActiveSubscriptions();
      }},
      (err)=>{}
      );

    (<any>window).twttr.widgets.load();
  }
  fetchTickets(): void {
    this.agileIntegration.fetchTickets().subscribe(
      (response) => {
        const tickets = response.agiletixEvents ? response.agiletixEvents : [];

        this.showcaseTickets = tickets.filter(
          (ticket) =>
            ticket.type !== undefined &&
            ticket.type !== null &&
            ticket.type.toLowerCase().includes('showcase')
        );
        this.showcaseTickets = this.showcaseTickets.sort(
          (a, b) =>
            new Date(a.StartDateTime).getTime() -
            new Date(b.StartDateTime).getTime()
        );
        if(this.showcaseTickets.find((v)=> (v.AccessStatus ==='AccessValid' || v.AccessStatus ==='BeforeEvent') && v.ParentID ==  this.movie.eventId)){
          this.isBuyButtonActive = true;
        }


      },
    );
  }

  getShowcaseList() {
 
      // agiletix data
        this.ShowcasesService.getMovieById(this.id).subscribe((res) => {
          this.movie = res;
          let url = `https://player.vimeo.com/video/${this.movie.trailer}?quality=1080p`;
          let url1 = `https://player.vimeo.com/video/${this.movie.video1}?quality=1080p`;
          let url2 = `https://player.vimeo.com/video/${this.movie.video2}?quality=1080p`;
          this.trailerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          this.splContent = this.sanitizer.bypassSecurityTrustResourceUrl(url1);
          this.splContent1 = this.sanitizer.bypassSecurityTrustResourceUrl(url2);
          if (this.movie.user > 0) {
            this.getSpotlightPremierList();
            this.getScreeningPartyList();
            this.fetchTickets();
          }
          this.id = res.id;
          this.errorApi =
            res.moviesArray == null ||
            res.moviesArray === 0 ||
            res.moviesArray.length === 0;
    
          this.checkForPurchaseCallback();
        });
    
  }

  openDialogRateMovie() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { movieId: this.id, moveDetails: this.movie }
    let movieId = this.id;
    this.dialog.open(RateMovieComponent, dialogConfig).afterClosed().subscribe((res) => {
      this.id = this.movie.eventId
      this.getShowcaseList()
    });;
  }

  openSideBar() {
    this.showSideBar = !this.showSideBar;
  }

  open(Id: number, movieList: any, purchaseStage: string): void {
    if (this.isAgileGateWayActive) {
      const modalRef = this.modalService.open(PurchaseFlowComponent, {
        size: 'xl',
        backdrop: 'static',
      });
      modalRef.componentInstance.eventId = Id;
      modalRef.componentInstance.premiere = movieList;
      modalRef.componentInstance.purchaseStage = purchaseStage;
    } else {
      if(this.isButtonClicked){
        return ;
      }
      this.isButtonClicked=true;

      this.authService.checkUserAuthenticated().subscribe(
        (res) => {
          if (res.userId === 0) {
            alert("Please login to creatics to purchase tickets.");
            this.isButtonClicked=false;
           location.href='/login?referer=cinejoy/showcase/moviepage/'+this.movie.eventId +'/'+ this.movie.name;
            
            return;
          }
          else{
            this.openSinglePurchaseDialog(Id, movieList);
                    }
        },
        (err) => {
          location.reload();
          this.isButtonClicked=false;
        }
      );

    }
  }

  openSinglePurchaseDialog(eventId: number, movieList: any) {
    this.populateCallbackUrl();
    localStorage.setItem(
      MovieInfoComponent.stripPaymentSessionEventIdKey,
      `${eventId}`
    );
    this.dialog
      .open(StripePurchasePopupComponent, {
        panelClass: 'pre-schedule-modalbox',
        width: '470px',
        height: 'auto',
        position: { top: '20px'},
        data: {
          eventId,
          eventType: EventType.SHOWCASE,
          showcaseEvent: movieList,
          mode: 'purchase',
          url: this.pageUrl,
          puchaseType: 'singlePurchase',
          purchaseTransactionType:'TICKET'
        },
      })
      .afterClosed()
      .subscribe((res) => {
        this.isButtonClicked=false;
      });
  }

  goAll() {
    document.getElementById('targetAll').scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }

  goAllScrollMobile() {
    document.getElementById('targetAllmobile').scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }
  navigateToScreeningParty() {

    this.routerurl.navigateByUrl(`/cinejoy/screening-parties/join`)
  }
  backClicked() {
    // this._location.back();
    //this is updated to prevent the user redirecting to stripe after payment completed and user click on back arrow
    this.routerurl.navigate(['/cinejoy/showcase']);

  }

  getSpotlightPremierList() {
    this.spotlightService.getData().subscribe((res) => {
      this.spotlightMovies = res;
    })
  }

  navigateToSpolightEvent(movie) {
    let name = movie.name.replace(/ /g, '-');
    this.routerurl.navigateByUrl(`/cinejoy/premiere/more-info/${movie.eventId}/${name}`)
  }

  checkSpotlightEvent(movie) {
    let item = this.spotlightMovies.filter((v) => v.eventId == movie.eventId)
    if (item.length) {
      return true;
    } else {
      return false;
    }
  }

  getmovieName(moviename) {
    let name = moviename.replace(/ /g, '-');
    return name;
  }

  getScreeningPartyList() {
    this.spotlightService.getScreeningPartyList().subscribe((res) => {
      this.screeningPartyList = res;
    }, (err) => {
    })
  }

  checkScreeningPartyEvent(movie) {
    let item = this.screeningPartyList.filter((v) => v.cinejoyFeaturedMovie == movie.eventId)
    if (item.length) {
      return true;
    } else {
      return false;
    }
  }

  navigateToScreeningPartyEvent(movie) {
    let name = movie.name.replace(/ /g, '-');
  }

  shareButton(type) {
    let searchParams = new URLSearchParams();
    let url;
    switch (type) {
      case 'facebook':
        searchParams.set('u', this.movie.legacyPurchaseLink);
        searchParams.set('title', this.movie.name);
        searchParams.set('text', this.movie.description);

        url = 'https://www.facebook.com/sharer/sharer?' + searchParams;
        break;
      case 'twitter':
        searchParams.set('url', "\n"+environment.apiURL + `cinejoy/showcase/moviepage/${this.movie.eventId}/${this.getmovieName(this.movie.name)}/${this.movie.cinejoyYears}`);
        searchParams.set('title', this.movie.name);
        searchParams.set('text', '\nExperience the Cinejoy Film Festival on Creatics.');
        url = 'https://twitter.com/share?' + searchParams;
        break;
    }
    this.share(url);
  }

  share(url) {
    return window.open(
      url,
      '_blank',
      'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=300,width=700,height=700'
    );
  }

  onLoad(event) {}
  private populateCallbackUrl() {
    this.pageUrl = window.location.href;
  }

  checkForPurchaseCallback() {
    const eventId = Number(
      localStorage.getItem(MovieInfoComponent.stripPaymentSessionEventIdKey)
    );
    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams.session_id && this.movie.eventId === eventId) {
        this.purchaseCallback = true;
        this.isBuyButtonActive=true;
        this.authService.checkUserAuthenticated().subscribe(
          (res) => {
            if (res.userId === 0) {
              alert('Session expired, Please login back to proceed further');
              location.href='/login?referer=cinejoy/showcase/moviepage/'+this.movie.eventId +'/'+ this.movie.name+ '&session_id=' + queryParams.session_id;
              return;
            }
            else{
              this.openStripPaymentConfirmationPopup( this.movie.eventId,this.movie,queryParams.session_id);
            }
          },
          (err) => {
            location.reload();
          }
        );

      }
    });
  }

  openStripPaymentConfirmationPopup(eventId, event, sessionId){
    this.dialog
          .open(StripePurchasePopupComponent, {
            panelClass: 'pre-schedule-modalbox',
            width: '600px',
            minHeight: 'auto',
            maxHeight:'75%',
            data: {
              eventId:eventId,
              eventType: 'SHOWCASE',
              showcaseEvent:event,
              mode: 'callback',
              sessionId: sessionId,
            },
          })
          .afterClosed()
          .subscribe((res) => {
            this.populateCallbackUrl();
          });
  }

  getActiveSubscriptions(){
    this.adminService.getActiveSubscription().subscribe(
      {
        next:(data:any[])=>{
          data.map(
            (item)=>{
              if(item.purchaseTransactionType==='SUBSCRIPTION_ALL'){
                this.isBuyButtonActive=true;
              }
              else if (item.purchaseTransactionType==='SUBSCRIPTION_SHOWCASE'){
                this.isBuyButtonActive=true;
              }
            }
          )
      },
      error:(error)=>{
        this.openStripeConfirmationPopup(error);
      }

    })
  }
  openStripeConfirmationPopup(error:any): void {
    this.dialog.open(StripeConfirmationPopupComponent, {
      // panelClass: 'pre-schedule-modalbox',
      width: '500px',
      minHeight: '15%',
      maxHeight:'50%',
      position:{
        top:'20px'
      },
      data: {
        invalidUsers:[],
        guestUsers:0,
        emptyTicketCount:0,
        ticketPrice:0 ,
        purchaseTransactionType:"subscriptionError",
        error:error
      }
    }).afterClosed().subscribe((res) => {
    })
  }

}